import React from "react";
import { Info } from "lucide-react";

export const DISCLAIMER_TEXT =
  "HostGuard Australia provides risk assessment guidance based on booking characteristics entered by the user. It does not verify guest identity, maintain a guest blacklist, or make final booking decisions. Hosts are responsible for complying with platform policies, privacy laws, anti-discrimination laws and local regulations.";

export const LegalDisclaimer = ({ compact = false, className = "" }) => {
  if (compact) {
    return (
      <p className={`text-xs leading-relaxed text-muted-foreground ${className}`} data-testid="legal-disclaimer">
        {DISCLAIMER_TEXT}
      </p>
    );
  }
  return (
    <div
      className={`flex gap-3 rounded-lg border border-border bg-muted/40 p-4 ${className}`}
      data-testid="legal-disclaimer"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
      <p className="text-xs leading-relaxed text-muted-foreground">{DISCLAIMER_TEXT}</p>
    </div>
  );
};
